import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Button } from '../../ui/Button/Button';
import { Panel } from '../../ui/Panel/Panel';
import { EmptyState } from '../../ui/EmptyState/EmptyState';
import { RowActions } from '../../ui/RowActions/RowActions';
import { PencilIcon } from '../../../assets/icons/icons';
import type { NewsItem } from '../../../types/news';
import styles from './NewsPreview.module.scss';

interface NewsPreviewProps {
    item: NewsItem | null;
    onEdit: (item: NewsItem) => void;
    onDelete: (item: NewsItem) => void;
}

export function NewsPreview({ item, onEdit, onDelete }: NewsPreviewProps) {

    const html = useMemo(() => DOMPurify.sanitize(item?.html ?? ''), [item?.html]);

    if (!item) {
        return (
            <Panel>
                <EmptyState
                    title="Новость не выбрана"
                    description="Выберите новость слева, чтобы увидеть её целиком."
                />
            </Panel>
        );
    }

    return (
        <Panel>
            <div className={styles.bar}>
                <span className={styles.eyebrow}>Предпросмотр</span>

                <span className={styles.barActions}>
                    <RowActions onEdit={() => onEdit(item)} onDelete={() => onDelete(item)} />
                </span>
            </div>

            <article className={styles.body}>

                <h2 className={styles.title}>{item.title}</h2>

                <div className={styles.text} dangerouslySetInnerHTML={{ __html: html }} />
            </article>

            <div className={styles.footer}>
                <Button variant="secondary" size="sm" icon={<PencilIcon />} onClick={() => onEdit(item)}>
                    Изменить
                </Button>

                {/* <Button variant="secondary" size="sm" onClick={() => onTogglePublication(item)}>
                    {item.status === 'published' ? 'Снять с публикации' : 'Опубликовать'}
                </Button> */}

                <span className={styles.hint}>Так новость выглядит на главной странице</span>
            </div>
        </Panel>
    );
}
